export default __webpack_public_path__ + "static/media/Dashboard_sitemap.4a51549f.jpg";